'use strict';
const angular = require('angular');

export class PostSummaryComponent {
  /*@ngInject*/
  constructor() {
  }

  getStoragePath(id) {
    if (this.public) {
      return "/api/storage/public/"+id+"/ctx/"+this.getContext(this.data);
    }

    return "/api/storage/"+id;
  }

  getPreviewText(text) {

    if (!text)
      return "";

    let textStrippedTags = String(text).replace(/<[^>]+>/gm, ' ');

    return textStrippedTags.length > 300 ? textStrippedTags.substr(0, 300) + '&hellip;' : textStrippedTags;
  }

  getUserShort(user) {
    try {
      return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
    } catch(e) {
      return "unknown";
    }
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  getContext(data) {
    return btoa(this.context+":"+data._id);
  }
}

export default angular.module('conduuApp.postSummary', [])
  .component('postSummary', {
    template: require('./PostSummary.html'),
    bindings: {
      data: '<',    // The Post itself
      user: '<',    // The User which created the post
      url: '@',     // The URL on which the full post can be read
      public: '<',  // Is this a public post ??
      context: '@'  // If public, we need the context (e.g. 'bulletin') for the permission
    },
    controller: PostSummaryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/post-summary/PostSummary.component.js